import { createContext, useContext } from 'react';
import type { RoundedModalContainerWidth, RoundedModalContainerHeight } from './rounded-modal';

type RoundedModalContainerContextType = {
  width: RoundedModalContainerWidth;
  height: RoundedModalContainerHeight;
};
export const RoundedModalContainerContext = createContext<RoundedModalContainerContextType>({
  width: 'sm',
  height: 'auto-height',
});
export const useRoundedModalContainerContext = () => {
  const context = useContext(RoundedModalContainerContext);
  if (context === undefined) {
    throw new Error('RoundedModalContainerContext must be used within a RoundedModalContainer');
  }
  return context;
};
